import * as actionTypes from './actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.marketing, action) {
  switch (action.type) {
    case actionTypes.SET_MARKETING_DATA:
      return { ...state, ...action.payload };
    case actionTypes.SET_OPT_STATUS:
      return { ...state, MARKETING: action.payload.MARKETING };
    case actionTypes.SET_OPT_OUT_CUSTOMER_FOR_SMS_MARKETING:
      return action.payload;
    case actionTypes.SET_OPT_IN_URL:
      return { ...state, urlOptIn: action.payload };
    case actionTypes.CLEAN_OPT_IN_URL:
      return { ...state, urlOptIn: action.payload };
    case actionTypes.CHANGE_OPT_STATUS:
      return { ...state, MARKETING: action.payload };
    case actionTypes.SET_DEFAULT_PROMOTION:
      return { ...state, isDefaultPromotionSet: action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/marketing/reducer.js